import React from "react";

const RetailersSubtitle: React.FC = () => {
    return (
        <>
            Dash helps you quickly understand the types of retailers in the area and how
            they position themselves to customers. Whether you're looking to blend in or
            stand out, you'll see how the local retail mix is shaped, making it easier to
            find your place in it.
        </>
    );
};

export default RetailersSubtitle;
